<template>
    <div
        class="moreMarket"
        v-bind:class="{
            isLive: event.isLive,
        }"
    >
        <BetBuilderRecommendation
            v-if="combinations.length > 0"
            v-gtm:page="'K_BB'"
            v-bind:event="event"
            v-bind:combinations="combinations"
        />
        <template
            v-for="group in singleBetTypeGroups"
            v-bind:key="group.key"
        >
            <BetBuilderBetType
                v-bind:event="event"
                v-bind:markets="group.markets"
            />
        </template>
        <BetBuilderMultipleBetType
            v-for="group in multipleBetTypeGroups"
            v-bind:key="group.key"
            v-bind:event="event"
            v-bind:group="group"
        />
        <StaticSpinner v-if="loading" />
    </div>
</template>

<script lang="ts" setup>
    import { toRefs } from 'vue';
    import BetBuilderRecommendation from '@/components/betBuilderRecommendation/BetBuilderRecommendation.vue';
    import StaticSpinner from '@/components/common/StaticSpinner.vue';
    import BetBuilderBetType from '@/components/oddsDisplay/moreMarket/marketType/BetBuilderBetType.vue';
    import BetBuilderMultipleBetType from '@/components/oddsDisplay/moreMarket/marketType/BetBuilderMultipleBetType.vue';
    import { useBetBuilderMoreMarket } from '@/components/oddsDisplay/moreMarket/useBetBuilderMoreMarket';
    import type { IEvent } from '@/interface/IEvent';
    import type { IBetBuilderCombination, IBetBuilderMarket } from '@/interface/betBuilder';

    const props = defineProps<{
        loading: boolean;
        event: IEvent;
        markets: IBetBuilderMarket[];
        combinations: IBetBuilderCombination[];
    }>();

    const { markets } = toRefs(props);

    const { singleBetTypeGroups, multipleBetTypeGroups } = useBetBuilderMoreMarket(markets);
</script>

<style lang="scss" scoped>
    @import "@/components/oddsDisplay/moreMarket/MoreMarket";
</style>
